import { render } from "./SuplierReport.vue?vue&type=template&id=c48f3012"
import script from "./SuplierReport.vue?vue&type=script&lang=js"
export * from "./SuplierReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__